import React from 'react';
import './home-view.css';

class HomeView extends React.Component {

  scrollToTop = () => window.scrollTo(0, 0);

  render() {
    return (
      <div className="container" style={{ marginTop: 40, marginBottom: 40, textAlign: 'center' }}>
      </div>
    );
  }
}

export default HomeView;
